import React, { FC, useState } from 'react';
import {
  Button,
  Col,
  Popconfirm,
  Row,
  Typography,
} from 'antd';
import { DownloadOutlined, SaveOutlined } from '@ant-design/icons';
import { RcFile } from 'antd/es/upload';
import Uploader from './Uploader';
import styles from './styles.module.less';

interface Props {
  isPlanning: boolean,
  isApplying: boolean,
  planComplete: boolean,
  exampleCsv: React.ReactElement,
  onApply: () => void,
  onExport: () => Promise<void>,
  isApplyDisabled?: boolean,
  onFileUpload: (file: RcFile) => void,
  fileName: string | null,
}

const UpdateToolUploadPanel: FC<Props> = ({
  isPlanning,
  isApplying,
  planComplete,
  exampleCsv,
  onExport,
  onApply,
  isApplyDisabled,
  onFileUpload,
  fileName,
}) => {
  const [exporting, setExporting] = useState<boolean>(false);
  return (
    <Row gutter={64} justify="space-between">
      <Col
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'left',
          flexDirection: 'row',
          marginTop: '20px',
        }}
      >
        <Uploader
          onChange={onFileUpload}
          fileName={fileName}
          isLoading={isPlanning}
        />
        {isPlanning
          ? (
            <div className={styles.warningMessage}>
              <p style={{ color: 'red' }}>
                The file is being processed, it may take a while...
              </p>
            </div>
          ) : (
            <div style={{ flex: 1, overflowX: 'auto', marginLeft: 20 }}>
              <div className={styles.rightContainer}>
                {planComplete && (
                  <>
                    <Button
                      icon={<DownloadOutlined />}
                      onClick={async () => {
                        setExporting(true);
                        await onExport();
                        setExporting(false);
                      }}
                      loading={exporting}
                    >
                      Export
                    </Button>
                    <Popconfirm
                      title="Sure to apply?"
                      onConfirm={() => {
                        // Prevent returning a promise, so the popup hides instantly
                        onApply();
                      }}
                      disabled={isApplyDisabled}
                    >
                      <Button
                        icon={<SaveOutlined />}
                        type="primary"
                        loading={isApplying}
                        disabled={isApplyDisabled}
                      >
                        Apply
                      </Button>
                    </Popconfirm>
                  </>
                )}
              </div>
              <Typography.Title level={5} style={{ margin: 5, textAlign: 'center' }}>
                CSV Example Format
              </Typography.Title>
              <div style={{ overflowX: 'auto', textAlign: 'center' }}>
                <div style={{ display: 'inline-block' }}>{exampleCsv}</div>
              </div>
            </div>
          )}
      </Col>
    </Row>
  );
};

export default UpdateToolUploadPanel;
